export default __webpack_public_path__ + "static/media/mountain-5.1239a7f6.png";